import { Modal, Button, Card } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';
import CurrentBenefitsPanel from './CurrentBenefitsPanel';
import BenefitSummaryPanelsRow from './BenefitSummaryPanelsRow';
import SubmitBenefitConfirmationFundTypeRenderer from './SubmitBenefitConfirmationFundTypeRenderer';
import { getFundTypeLabel } from '../../utils/fundTypeUtils';

const SubmitBenefitConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  isSubmitting,
  formData,
  formSnapshot,
  agencyOverride,
  submissionPayload,
}) => {
  if (!show || !formSnapshot) {
    return null;
  }

  const accountId = formData?.accountId;
  const fundType = formSnapshot?.fundType;
  const fundTypeLabel = getFundTypeLabel(fundType);

  const normalizedFundType = fundType?.toUpperCase();
  const isCares = normalizedFundType === 'CARES';
  const pledgesForFundType = isCares
    ? []
    : (formData?.pledgesAppliedWithCurrentProgramYear?.[normalizedFundType] ?? []);

  const numGrants = isCares
    ? formData?.caresPledgesApplied
    : pledgesForFundType.length;

  const totalGrantsApplied = isCares
    ? formData?.totalCaresGrantsApplied
    : Math.abs(pledgesForFundType.reduce((sum, p) => sum + (p.pledgeAmount ?? 0), 0));

  return (
    <Modal show={show} onHide={onClose} size="lg" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm {fundTypeLabel} Benefit Submission - {accountId}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="bg-secondary-soft">
          <Card.Body>
            <BenefitSummaryPanelsRow
              customerProps={{
                customerFirstName: formData?.customerFirstName,
                customerLastName: formData?.customerLastName,
                serviceAddress: formData?.serviceAddress,
                serviceCity: formData?.serviceCity,
                serviceState: formData?.serviceState,
                serviceZip: formData?.serviceZip,
                county: formData?.county,
              }}
              currentBenefitsProps={{
                state: formData?.state,
                fundType,
                currentEnergyDiscount: formData?.currentDiscountPercentage,
                numGrants,
                totalGrantsApplied,
              }}
              agencyProps={{
                agencyName: agencyOverride?.agencyName || formData?.agencyName,
                agencyEmail: agencyOverride?.agencyEmail || formData?.agencyEmail,
                username: agencyOverride?.username || formData?.username,
              }}
              canOverrideAgency={false}
            />
          </Card.Body>
        </Card>

        <SubmitBenefitConfirmationFundTypeRenderer
          state={formData?.state}
          formSnapshot={formSnapshot}
          submissionPayload={submissionPayload}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? (
            <LoadingSpinner inline message="Submitting..." />
          ) : (
            'Confirm Submit'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubmitBenefitConfirmationModal;
